<template>
	 <defaultTemplate>
        <div class="card rounded">
        	<div class="card-content">
                <div>
                    <router-link to="/assign-form">
                        <i class="fas fa-arrow-left"></i>
                    </router-link>
                </div>
        		<h1 class="has-text-centered mg-y-1">ตั้งค่าแบบฟอร์ม</h1>
        		<div class="columns flex-warp">
        			<div class="column is-6-desktop">
        				<b-field label="ชื่อหน่วยงาน" class="mg-b-2">
				        	<b-input v-model="form.departmentName"></b-input>
				        </b-field>
        			</div>
        			<div class="column is-6-desktop">
        				<b-field label="รายละเอียดหน่วยงาน " class="mg-b-2">
				        	<b-input v-model="form.description"></b-input>
				        </b-field>
        			</div>
        			<div class="column is-6-desktop">
        				<div class="columns">
        					<div class="column is-9">
        						<p class="mg-b-5">โลโก้หน่วยงาน</p>
        						<div class="file-name mg-r-5" >
						            {{ form.logo }}
						        </div>
        					</div>
        					<div class="column is-3 has-text-right is-flex ai-end">
        						<b-upload class="w-100" @input="handleFile($event)">
						            <a class="w-100 button is-primary" >
						            		<span>เลือกไฟล์</span>
						            </a>
		        				</b-upload>
        					</div>
        				</div>
        			</div>
        		</div>
        		<div class="columns flex-warp">
        			<div class="column is-3-desktop">
        				<div>
        					<p class="mg-b-5">Theme Admin</p>
        				</div>
        				<div>
        					<b-input class=" float-left" v-model="form.themeAdmin"></b-input>
        					<v-swatches 
					        	v-model="form.themeAdmin" 
					        	show-fallback
								popover-x="left" class="mg-l-5  float-left">
							</v-swatches>
        				</div>
        			</div>
        			<div class="column is-3-desktop">
        				<div>
        					<p class="mg-b-5">Secondary Admin</p>
        				</div>
        				<div>
        					<b-input class="float-left" v-model="form.buttonAdmin"></b-input>
        					<v-swatches 
					        	v-model="form.buttonAdmin" 
					        	show-fallback
								popover-x="left" class="mg-l-5 float-left">
							</v-swatches>
        				</div>
        			</div>
        			<div class="column is-3-desktop">
        				<div>
        					<p class="mg-b-5">Theme Staff</p>
        				</div>
        				<div>
        					<b-input class="float-left" v-model="form.themeStaff"></b-input>
        					<v-swatches 
				        	v-model="form.themeStaff" 
				        	show-fallback
							popover-x="left" class="mg-l-5 float-left">
						</v-swatches>
        				</div>
        			</div>
        			<div class="column is-3-desktop">
        				<div>
        					<p class="mg-b-5">Secondary Staff</p>
        				</div>
        				<div>
	        				<b-input class="float-left" v-model="form.buttonStaff"></b-input>
					        <v-swatches 
					        	v-model="form.buttonStaff" 
					        	show-fallback
								popover-x="left" class="mg-l-5 float-left">
							</v-swatches>
        				</div>
        			</div>
        		</div>
        		<div class="has-text-centered">
        			<b-button @click="saveTemplate()"  :style="styleObject" class="mg-y-1 button-secondary">บันทึก</b-button>
        		</div>
        	</div>
        </div>
    </defaultTemplate>
</template>
<script>
import defaultTemplate from '@/template/DefaultTemplate'
import VSwatches from 'vue-swatches'
import { HTTP } from "@/service/axios.js";
export default {
    name: "changeLog",
    mounted(){
    	this.getTemplate()
    },
    methods:{
    	handleFile(event){
    		console.log(event)
    		const file = event;
    		const formData = new FormData();
	        formData.append('departmentImg', file);
	        formData.append('deleteImg', this.form.logo);
	        const config = {
	          headers: {
	            'Content-Type': 'multipart/form-data',
	          },
	        };
	        HTTP.post('/upload/department/image', formData, config).then((res) => {
	          	this.form.logo = res.data.name
	        });
    	},
    	getTemplate(){
    		HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
    		HTTP.get(`/template/${this.$route.params.userId}`).then(res=>{
    			if(res.data.success){
    				if(typeof res.data.obj.template != 'undefined'){
    					this.form.buttonAdmin = res.data.obj.template.buttonAdmin
    					this.form.buttonStaff = res.data.obj.template.buttonStaff
    					this.form.departmentName = res.data.obj.template.departmentName
    					this.form.description = res.data.obj.template.description
    					this.form.logo = res.data.obj.template.logo
    					this.form.themeAdmin = res.data.obj.template.themeAdmin
    					this.form.themeStaff = res.data.obj.template.themeStaff
    				}
    			}
    		})
    	},
    	saveTemplate(){
    		this.form.userId = this.$route.params.userId
    		HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
			HTTP.put(`/assign/template`,this.form).then(res=>{
    			if(res.data.success){
                    this.$buefy.toast.open({ message: "บันทึกสำเร็จ", type: "is-success" ,duration:3000});
    			}
    		})
    	}
    },
    computed:{
    	user(){
    		return this.$store.state.user
    	}
    },
    data(){
    	return{
    		fileDelete:[],
    		color: '#1CA085',
    		form:{
    			departmentName: "",
			   	description: "",
			   	logo: "",
			   	themeAdmin: "#1A1A8B",
			   	buttonAdmin: "#5081FE",
			   	themeStaff: "#B70004",
			   	buttonStaff: "#F74F4F"
    		}
    		
    	}
    },
    components: {
        defaultTemplate,
        VSwatches 
    },
    

}
</script>

<style scoped>
	.file-name {
	    border-color: #dbdbdb;
	    border-style: solid;
	    border-width: 1px 1px 1px 1px;
	    display: block;
	    overflow: hidden;
	    text-align: left;
	    text-overflow: ellipsis;
	    max-width: 100%;
	}
</style>